import { oliveBackgroundTokens } from '@ds/tokens'

const tokens = {
  opacityLevel: 0.5,
  defaultBackgroundColor: oliveBackgroundTokens.bgColorScrim,
} as const

export default tokens
